export const pushGAInteraction = (gaInteraction) =>
  window.dataLayer && window.dataLayer.push(gaInteraction);
